import equal from 'fast-deep-equal'

import { deepToRaw } from './deepToRaw'

const normalizeForEqual = (value: unknown): unknown => {
  if (value !== null && typeof value === 'object') {
    return deepToRaw(value as Record<string, unknown>)
  }

  return value
}

export const isDeepEqual = (a: unknown, b: unknown): boolean => equal(normalizeForEqual(a), normalizeForEqual(b))
